import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import pick from 'lodash/pick'
import { RouterState } from 'connected-react-router'

import { updateFilters } from '../../actions/myBucketlistActions'
import { deserializeSearchQuery } from '../../actions/utils/search'

import DatesFilter from '../../search/filters/desktop/DatesFilter'
import CapacityFilter from '../../search/filters/desktop/CapacityFilter'
import { normalizeKeys } from '../../components/utils/propsUtils'

const Wrapper = styled.div`
  display: flex;
  margin: 0 -16px;
`

const Filter = styled.div`
  padding-left: 16px;

  &:last-child {
    padding-right: 0;
  }
`

interface BucketListFiltersProps {
  filters: Maybe<GQL_SearchFilters>
  dispatch: (...args: any) => any
}

const DesktopBucketListFilters: FunctionComponent<BucketListFiltersProps> = ({
  filters,
  dispatch,
}) => {
  const onFiltersChange = (newFilters: GQL_SearchFilters) => {
    dispatch(updateFilters(newFilters))
  }

  return (
    <Wrapper>
      <Filter>
        <DatesFilter
          valueKey="dates"
          startDate={filters.startDate}
          endDate={filters.endDate}
          onChange={onFiltersChange}
        />
      </Filter>

      <Filter>
        <CapacityFilter
          valueKey="capacity"
          values={pick(filters, ['adults', 'children'])}
          onChange={onFiltersChange}
        />
      </Filter>
    </Wrapper>
  )
}

interface ReduxState {
  router: RouterState
}

export default connect(({ router }: ReduxState) => ({
  filters: normalizeKeys(deserializeSearchQuery(router.location.search)),
}))(DesktopBucketListFilters)
